import { Component } from "react";
import { AlertTriangle } from "lucide-react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info);
  }

  reset = () => {
    this.setState({ hasError: false });
    window.location.href = "/";
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        className="lightboard"
        data-testid="error-boundary"
        style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}
      >
        <div className="panel-card" style={{ maxWidth: 420, padding: 28, textAlign: "left" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, color: "var(--orange)" }}>
            <AlertTriangle size={18} />
            <span className="font-mono" style={{ fontSize: 11, letterSpacing: "0.12em", textTransform: "uppercase" }}>
              System Fault
            </span>
          </div>
          <h2 className="font-display" style={{ fontSize: 20, fontWeight: 600, color: "var(--tprimary)", margin: "14px 0 8px" }}>
            Something went off-blueprint.
          </h2>
          <p className="font-body" style={{ fontSize: 14, color: "var(--tsecondary)", lineHeight: 1.55, margin: 0 }}>
            An unexpected error interrupted the studio. Your saved brands are safe — reload to continue.
          </p>
          <button
            data-testid="error-boundary-reset"
            className="btn-primary"
            style={{ marginTop: 20, padding: "10px 16px" }}
            onClick={this.reset}
          >
            Reload Studio
          </button>
        </div>
      </div>
    );
  }
}
